export default "__VITE_ASSET__YqBqIQx8__"